import { tw } from '@/utils/tw';
import BaseArticlePaywallTheme from 'base/components/standalone/ArticlePaywall/theme';

export const AllasPaywallFormTheme = tw.theme({
  extend: BaseArticlePaywallTheme,
  slots: {
    base: ['bg-logga-300'],
    headline: ['text-headline-sm', '!font-normal'],
    description: ['text-body-sm', 'sm:text-body-md'],
    feature: ['text-body-sm', 'items-center'],
    policy: ['text-body-sm'],
  },
});

export default Object.assign(AllasPaywallFormTheme, {
  Form: BaseArticlePaywallTheme.Form,
  SuccessfulPayment: BaseArticlePaywallTheme.SuccessfulPayment,
  FrisbiiPayment: BaseArticlePaywallTheme.FrisbiiPayment,
  Dialog: BaseArticlePaywallTheme.Dialog,
});
